module.exports = __webpack_public_path__ + "summernote.f4a47ce92c02ef70fc84.eot";


//////////////////
// WEBPACK FOOTER
// ./~/summernote/dist/font/summernote.eot
// module id = 281
// module chunks = 3